var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

// Update all wishlist count badges on the page
var updateWishlistCount = function () {
  var wishlist = getWishlist();
  var count = wishlist.length;
  var countEls = document.querySelectorAll('.wishlist-count, [data-wishlist-count]');
  countEls.forEach(function (el) {
    el.textContent = count;
    if (count > 0) {
      el.classList.add('has-items');
    } else {
      el.classList.remove('has-items');
    }
    el.classList.remove('badge-pulse');
    void el.offsetWidth; // Trigger reflow
    el.classList.add('badge-pulse');
    setTimeout(function () {
      el.classList.remove('badge-pulse');
    }, 350);
  });
};

// Open Wishlist Popup Modal
var openWishlistPopup = function (productData) {
  var modal = document.getElementById('wishlistModal');
  if (!modal) return;

  var imgEl = document.getElementById('wishlistModalImg');
  var titleEl = document.getElementById('wishlistModalProductTitle');
  var priceEl = document.getElementById('wishlistModalProductPrice');

  if (productData) {
    if (imgEl && productData.img) {
      imgEl.src = productData.img;
      imgEl.style.display = 'block';
    } else if (imgEl) {
      imgEl.style.display = 'none';
    }

    if (titleEl && productData.title) {
      titleEl.textContent = productData.title;
    }

    if (priceEl) {
      if (productData.price) {
        priceEl.textContent = productData.price;
        priceEl.style.display = 'block';
      } else {
        priceEl.style.display = 'none';
      }
    }
  }

  modal.style.display = 'flex';
  requestAnimationFrame(function () {
    modal.classList.add('is-open');
  });
  document.body.style.overflow = 'hidden';
};

// Close Wishlist Popup Modal
var closeWishlistPopup = function () {
  var modal = document.getElementById('wishlistModal');
  if (!modal) return;

  modal.classList.remove('is-open');
  setTimeout(function () {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }, 250);
};

document.addEventListener('DOMContentLoaded', function () {
  // Initialize count immediately
  updateWishlistCount();

  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) {
    setupGrid(grid);
  }

  // Setup modal close events
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-close]')) {
      e.preventDefault();
      closeWishlistPopup();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeWishlistPopup();
    }
  });
});

// Sync count across browser tabs
window.addEventListener('storage', function (e) {
  if (e.key === LOCAL_STORAGE_WISHLIST_KEY) {
    updateWishlistCount();
    var buttons = document.querySelectorAll(selectors.button) || [];
    buttons.forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      if (handle) {
        btn.classList.toggle(BUTTON_ACTIVE_CLASS, wishlistContains(handle));
      }
    });
  }
});

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var wihslitExistBtn = document.querySelector('.wishlist-page');
  if (wishlist.length > 0 && wihslitExistBtn) {
    wihslitExistBtn.classList = 'wishlist_exists';
  }
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    var buttons = grid.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    if (button.dataset.wishlistBound === 'true') return;
    button.dataset.wishlistBound = 'true';

    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    
    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    } else {
      button.classList.remove(BUTTON_ACTIVE_CLASS);
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      var wasIn = wishlistContains(productHandle);
      updateWishlist(productHandle);

      if (!wasIn) {
        button.classList.add(BUTTON_ACTIVE_CLASS);
        // Gather product info for modal
        var title = button.dataset.productTitle;
        if (!title) {
          var titleEl = document.querySelector('.product-details h2, .product-title, h1.product-title, h1');
          title = titleEl ? titleEl.textContent.trim() : document.title;
        }

        var img = button.dataset.productImg;
        if (!img) {
          var imgEl = document.querySelector('.product-details-images img, .main-image img, .product-media img, #ProductPhotoImg');
          img = imgEl ? imgEl.src : '';
        }

        var price = button.dataset.productPrice;
        if (!price) {
          var priceEl = document.querySelector('.product-details .price, .product-price, #ProductPrice');
          price = priceEl ? priceEl.textContent.trim() : '';
        }

        openWishlistPopup({
          title: title,
          img: img,
          price: price,
          handle: productHandle
        });
      } else {
        button.classList.remove(BUTTON_ACTIVE_CLASS);
      }

      updateWishlistCount();
    });
  });
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  var res = setWishlist([]);
  updateWishlistCount();
  return res;
};

// Global exports if needed
window.updateWishlistCount = updateWishlistCount;
window.openWishlistPopup = openWishlistPopup;
window.closeWishlistPopup = closeWishlistPopup;